import { render, staticRenderFns } from "./ModalPreviewSaveData.vue?vue&type=template&id=2cfd4ef6&scoped=true&"
import script from "./ModalPreviewSaveData.vue?vue&type=script&lang=js&"
export * from "./ModalPreviewSaveData.vue?vue&type=script&lang=js&"
import style0 from "./ModalPreviewSaveData.vue?vue&type=style&index=0&id=2cfd4ef6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfd4ef6",
  null
  
)

export default component.exports